/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Box, Typography } from "@mui/material";
import { FC } from "react";

import __ from "web/Layout/Translations";

interface IFieldPreviewProps {
  label: string;
  value?: string;
  id?: string;
  showRedValue?: boolean;
}

const FieldPreviewMUI: FC<IFieldPreviewProps> = ({
  label,
  value = "",
  id,
  showRedValue = false,
}) => {
  // eslint-disable-next-line no-nested-ternary
  const valueFormatted = value?.length
    ? value
    : showRedValue
    ? __("brak danych")
    : "-";

  return (
    <Box display="flex" alignItems="center" mb="2px" data-t1={id}>
      <Typography variant="body2" mr={0.5} sx={{ whiteSpace: "nowrap" }}>
        {label}:
      </Typography>
      <Typography
        variant="subtitle2"
        fontWeight={700}
        sx={{ wordBreak: "break-word" }}
        color={showRedValue ? "#C62828" : "#000000"}
      >
        {valueFormatted}
      </Typography>
    </Box>
  );
};

export default FieldPreviewMUI;
